const main = () => {
    if(document.querySelector('.l-header-menu') === null) return;

    document.querySelectorAll('[data-open-hamburger]')
    .forEach(element => {
        element.addEventListener('click', (e) => {
            console.log('Hamburger toggled');
            e.preventDefault();
            document.body.toggleAttribute("data-menu-active")
        });
    });
}

export default main
